import React from "react";
import {
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import NextRouter from "next/router";
import { mainPageQuestions, subPageQuestions } from "./data";
import CustomCollapse from "../collapse/Collapse";
import { makeStyles } from'@mui/styles';

const useStyles = makeStyles({
  helpTopicCard: {
    borderRadius: 8,
    width: 262,
    height: 260,
    border: "1px solid rgba(0, 27, 17, 0.3)",
    "&:hover": {
      filter: "drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.2))",
    },
  },
  helpTopicCardContent: {
    height: "100%",
    padding: 0,
  },
  cardButton: {
    boxShadow: "none",
    padding: 0,
    textTransform: "unset",
  },
  grid100: {
    height: "100%",
  },
  cardTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 24,
    lineHeight: "150%",
    color: "#001B11",
  },
  headerstyle: {
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: 30,
    lineHeight: "150%",
    textAlign: "center",
    color: "#001B11",
    margin: "2rem auto 2rem auto",
  },
});

const HelpUI = () => {
  const classes = useStyles();

  return (
    <>
      <Typography className={classes.headerstyle} role="heading" aria-level="2" >Popular Topics</Typography>
      <Container fixed>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={7}
        >
          {subPageQuestions &&
            subPageQuestions.map((item, i) => (
              <Grid item key={"button" + i}>
                <Button
                  style={{ padding: 0, marginBottom: "1rem" }}
                  className={classes.cardButton}
                  onClick={() =>
                    NextRouter.push(`/helpdoc?page=${item.pageName}`)
                  }
                >
                  <Card className={classes.helpTopicCard}>
                    <CardContent className={classes.helpTopicCardContent}>
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        className={classes.grid100}
                      >
                        <Grid item>{item.icon}</Grid>
                        <Grid item>
                          <Typography
                            component="p"
                            className={classes.cardTitle}
                          >
                            {item.groupName}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Button>
              </Grid>
            ))}
        </Grid>
      </Container>
      <Typography className={classes.headerstyle} role="heading" aria-level="2" >
        Recommended for you
      </Typography>
      <Container maxWidth="md">
        {mainPageQuestions &&
          mainPageQuestions.map((item, i) => (
            <CustomCollapse
              question={item.question}
              answer={item.answer}
              key={"question" + i}
              role="region"
            />
          ))}
      </Container>
    </>
  );
};

export default HelpUI;
